import * as React from 'react';
import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';

const devxpPage = PageBlueprint.make({
  params: {
    path: '/devxp',
    title: 'Dev Intelligence',
    loader: () =>
      import('./components/DevxpPage').then(m => React.createElement(m.DevxpPage, null)),
  },
});

export default createFrontendPlugin({
  pluginId: 'devxp',
  extensions: [devxpPage],
});
